"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var hmr_store_1 = require('./hmr-store');
__export(require('./webpack-hmr'));
__export(require('./hmr-decorator'));
__export(require('./hmr-store'));
function provideHmrState(initialState) {
    if (initialState === void 0) { initialState = {}; }
    return [
        { provide: hmr_store_1.HMR_STATE, useValue: initialState },
        { provide: hmr_store_1.HmrStore, useValue: hmr_store_1.HmrStore }
    ];
}
exports.provideHmrState = provideHmrState;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/angular2-hmr/dist/index.js
 ** module id = 1027
 ** module chunks = 0
 **/